import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint: number = 600) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // For testing on desktop
      // const smallerDimension = Math.min(window.innerWidth, window.innerHeight);
      const smallerDimension = Math.min(window.screen.width, window.screen.height);
      setIsMobile(smallerDimension < breakpoint);
    };

    // Initial check
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile